var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "passord skjules",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.983 18.3525C7.74509 19.399 9.80201 20 12 20C17 20 21.27 16.89 23 12.5C22.4136 11.0121 21.5355 9.6712 20.4361 8.54862L16.7798 11.0288C16.9229 11.494 17 11.988 17 12.5C17 15.26 14.76 17.5 12 17.5C10.8143 17.5 9.72452 17.0866 8.86713 16.3961L5.983 18.3525ZM10.6548 15.1835C11.0591 15.3861 11.516 15.5 12 15.5C13.66 15.5 15 14.16 15 12.5C15 12.4135 14.9964 12.3279 14.9892 12.2433L10.6548 15.1835ZM13.4293 9.86035L9.02022 12.8512C9.00686 12.736 9 12.6188 9 12.5C9 10.84 10.34 9.5 12 9.5C12.5179 9.5 13.0047 9.63044 13.4293 9.86035ZM15.2002 8.65911C14.3329 7.93552 13.217 7.5 12 7.5C9.24 7.5 7 9.74 7 12.5C7 13.0425 7.08655 13.565 7.24659 14.0543L3.62358 16.5118C2.49623 15.3771 1.59692 14.0147 1 12.5C2.73 8.11 7 5 12 5C14.2309 5 16.3165 5.61913 18.096 6.69485L15.2002 8.65911Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79321 20.0049L1.67051 18.3497L21.2442 5.07278L22.3669 6.72794L2.79321 20.0049Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordHide);
export default __webpack_public_path__ + "static/media/passwordHide.11888834.svg";
export { ForwardRef as ReactComponent };